<template>
  <svg width="38" height="44" viewBox="0 0 38 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.9398 37.3515C32.0381 35.177 38 27.7848 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 27.7848 5.96187 35.1771 14.0602 37.3515L18.9999 44L23.9398 37.3515Z" fill="#231F20"/>
<path d="M16.8094 26.0229V24.0458M20.5911 26.0229V24.0458M20.5911 24.0458V20.4869M20.5911 24.0458H24.5967M16.8094 24.0458H12.8039M16.8094 24.0458V20.4869M22.9945 28V25.232M22.9945 28H24.9972M22.9945 28H14.4061M24.9972 28H27V26.0458C27 24.9412 26.1046 24.0458 25 24.0458H24.5967M24.9972 28V25.232M14.4061 28V25.232M14.4061 28H12.4033M12.4033 28H10V26.0458C10 24.9412 10.8954 24.0458 12 24.0458H12.8039M12.4033 28V25.232M12.8039 24.0458V24.0458C12.8039 22.0803 14.3972 20.4869 16.3627 20.4869H16.8094M16.8094 20.4869V15.0498M20.5911 20.4869H21.0379C23.0033 20.4869 24.5967 22.0803 24.5967 24.0458V24.0458M20.5911 20.4869V15.0498M16.8094 13.0727V10.2059L18.7297 6L20.5911 10.2059V13.0727M16.8094 13.0727H20.5911M16.8094 13.0727L16.0083 15.0498H16.8094M20.5911 13.0727L21.3922 15.0498H20.5911M16.8094 15.0498H20.5911" stroke="white" stroke-width="1.5"/>
<path d="M21.5 28C21.5 26.3431 19.7533 25.0035 18.6027 25.0035C17.4521 25.0035 16 26.3431 16 28" stroke="white" stroke-width="1.5"/>
</svg>
</template>

<script>
export default {
  name: 'PanoramaIconMosque'
}
</script>

<style scoped>

</style>
